import { __decorate, __metadata } from "tslib";
import { v4 as uuidv4 } from "uuid";
import { Type } from "class-transformer";
import { AddressModel } from "../shared/address";
let ClientModel = /** @class */ (() => {
    class ClientModel {
        constructor() {
            this.id = uuidv4();
            this.name = "";
            this.description = "";
            this.webSite = "";
            this.linkedIn = "";
            this.twitter = "";
            this.startDate = null;
            this.serviceStatementDate = null;
            this.sowDate = null;
            this.psaDate = null;
            this.phoneNumber = "";
            this.csmId = null;
            this.tsmId = null;
            // file?: FormData;
            // @Type(() => ClientContactModel)
            // clientContacts?: IClientContactDTO[] = [];
            // @Type(() => PMOTeamModel)
            // teams?: IPMOTeamDTO[] = [];
            this.addresses = [];
        }
    }
    __decorate([
        Type(() => AddressModel),
        __metadata("design:type", Array)
    ], ClientModel.prototype, "addresses", void 0);
    return ClientModel;
})();
export { ClientModel };
export default class Client extends ClientModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
